export const routes = {
  MAIN: '/catalog',
  // CATALOG_MODEL: '/catalog/model',
  CATALOG_MODEL: '/catalog/:type/:mark',
  CATALOG_MODIFICATION: '/catalog/:type/:mark/:model',
  CATALOG_GROUPS: '/catalog/:type/:mark/:model/:modification',
  CATALOG_SCHEME: '/catalog/:type/:mark/:model/:modification/:group/:parentId',
  CATALOG_FILTERS: '/catalog/:type/:mark/:model/:modification/:group/:parentId/:searchText',
  CATALOG_SEARCH_BAR_RESULTS: '/catalog/search/:searchText',
  CATALOG_CART: '/catalog/cart',

  TRANSACTIONS_HISTORY: '/transactionsHistory',
  RETURNS: '/returns',
  SETTINGS: '/settings',
  ORDERS: '/orders',

  SIGN_IN: '/signin',
  SIGN_UP: '/signup',
  PASSWORD_RECOVERY: '/password-recovery',
  PAGE_NOT_FOUND: '/404',
};
